import { useState, useCallback } from 'react';

let nextId = 0;

export default function useFlash() {
    const [messages, setMessages] = useState([]);

    const flash = useCallback((message, type = 'danger') => {
        const id = ++nextId;
        setMessages(prev => [...prev, { id, message, type }]);
    }, []);

    const remove = useCallback((id) => {
        setMessages(prev => prev.filter(m => m.id !== id));
    }, []);

    return { messages, flash, remove };
}
